export default __webpack_public_path__ + "static/media/accountBg.d531b485.png";